
export const styles = {
  container: {
    backgroundColor: 'synthwave-container',
    minHeight: '250px'
  },
  header: {
    background: 'bg-gradient-to-r from-fuchsia-900 via-purple-900 to-pink-900',
    textColor: 'text-cyan-300',
    border: ''
  },
  avatar: {
    background: 'synthwave-avatar',
    text: 'text-pink-400',
    border: 'border border-pink-400',
    shape: 'rounded-full aspect-square overflow-hidden'
  },
  messages: {
    bot: {
      background: 'synthwave-message',
      text: 'text-fuchsia-100',
      border: ''
    },
    user: {
      background: 'synthwave-message',
      text: 'text-white',
      border: ''
    }
  },
  typingIndicator: {
    container: 'synthwave-message',
  },
  footer: {
    text: 'text-fuchsia-200',
    link: 'text-fuchsia-300 hover:underline'
  }
}; 